<template lang="html">
    <div class="z-deal-issue-status-changer">
        <z-select
            class="z-deal-issue-status-changer__select" name="issue_status_id" id="issue_status_id" 
            v-bind:label="( $props.hideLabel ? '' : 'Статус выдачи')"
            v-model="val" 
            v-bind:disabled="$props.disabled"
            v-on:change="onChange"
        >
            <option v-bind:value="1">Выдача разрешена</option>
            <option v-bind:value="2">Выдача запрещена</option>
            <option v-bind:value="3">Выдача разрешена (экспедирование)</option>
        </z-select>
        <div class="z-deal-issue-status-changer__actions">

            <md-button
                class="md-icon-button md-dense close small"
                v-on:click="onRecalc" v-bind:disabled="disabledRecalc"
            >
                <i class="fas fa-sync-alt"></i>
                <md-tooltip md-direction="top" md-delay="500">Обновить сальдо</md-tooltip>
            </md-button>

            <z-tool-menu v-if="debt && debt.payers" v-bind:active="showDebtors">
                <template slot="action" slot-scope="scope">
                    <md-button class="md-icon-button md-dense close small" v-on:click="toggleDebtors">
                        <i class="fas fa-chevron-down"></i>
                    </md-button>
                    <md-tooltip md-direction="top" md-delay="500">Показать детали</md-tooltip>
                </template>
                <div class="z-deal-issue-status-changer__debtors">
                    <div class="z-deal-issue-status-changer__debtor" v-for="(payer, i) in debt.payers" v-bind:class="{'even': (i%2 == 0), 'odd': (i%2 != 0)}">
                        <div class="z-deal-issue-status-changer__debtor-label">{{ payer.name }}</div>
                        <div class="z-deal-issue-status-changer__debtor-value" v-bind:class="{'deny': (parseInt(payer.debt) < 0), 'allow': (parseInt(payer.debt) > 0)}">
                            <span v-if="parseInt(payer.debt) >= 0">Депозит:</span>
                            <span v-if="parseInt(payer.debt) < 0">Задолженность:</span>
                            <b>{{ `${price.format(payer.debt)} руб.` }}</b>
                        </div>
                    </div>
                </div>
            </z-tool-menu>
        </div>
    </div>
</template>
<script>
    import ZSelect from '@/components/ZSelect';
    import ZInput  from '@/components/ZInput';
    import ZTextArea from '@/components/ZTextArea';
    import ZToolMenu from '@/components/ZToolMenu';
    import price from '@/helpers/price/index.js';
    export default {
        name: 'z-deal-issue-status-changer',
        components: {ZSelect, ZInput, ZTextArea, ZToolMenu},
        props: {
            dealId: {
                type: Number,
                default: null
            },
            value: {
                type: [Number, String],
                default: () => 0
            },
            disabled: {
                type: Boolean,
                default: false
            },
            disabledRecalc: {
                type: Boolean,
                default: false
            },            
            hideLabel: {
                type: Boolean,
                default: false
            },
            payers: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                val: 0,
                oldVal: 0,
                showDebtors: false,
                price: price,
            }
        },
        created() {
            this.val = parseInt(this.$props.value);
            this.oldVal = parseInt(this.$props.value);
        },
        watch: {
            '$props.value'(n, o) {
                if (n != this.val) {
                    this.val = parseInt(n);
                    this.oldVal = parseInt(o)
                }
            },
            'val'(n, o) {
                this.$emit('change', n);
                this.$emit('input', n);
                this.oldVal = parseInt(o)
            }
        },
        computed: {
            debt() {
                if (!this.payers || !this.payers.length) return {issue: false, payers: []};
                return {
                    issue:  this.payers.every(p => p.issue === true),
                    payers: this.payers
                };
            },            
        },
        methods: {
            toggleDebtors() {
                this.showDebtors = !this.showDebtors
            },
            onRecalc() {
                this.$emit('recalc');
            },
            onChange() {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в изменении статуса выдачи груза?', '',
                    () => this.setStatus(this.val),
                    () => this.val = this.oldVal
                );
            },
            setStatus(id) {
                return this.$store.dispatch('deals/setDealIssueStatus', {id: this.$props.dealId, status_id: id}).then(r => {
                    this.$store.commit('showSnackbar', ['Статус выдачи обновлён, обновление формы...', 6000, 'success']);
                });
            }
        }
    }
</script>
<style scoped lang="sass">
    .z-deal-issue-status-changer
        width: 100%
        display: flex
        align-items: flex-end
        justify-content: flex-start
        margin: 0 10px 0 0
        .z-deal-issue-status-changer__actions
            display: flex
            align-items: center
            justify-content: flex-start
            margin: 4px 0 10px 0
        .z-deal-issue-status-changer__debtors
        .z-deal-issue-status-changer__debtor
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
            padding: 5px 6px
            margin: -5px            
        .z-deal-issue-status-changer__debtor-label
            width: 100%
            max-width: 350px
            white-space: nowrap
            text-overflow: ellipsis
            overflow: hidden
        .z-deal-issue-status-changer__debtor-value
            width: 100%
            display: flex
            align-items: center
            justify-content: space-between
            span
                margin: 0 10px 0 0
            b
            text-align: right
            margin: auto 0 auto auto
            &.allow
                b
                    color: #67d665
            &.deny
                b
                    color: #d66565
            &.odd
                background: #eee
            &.even            
</style>



// WEBPACK FOOTER //
// ZDealIssueStatusChanger.vue?7e0e4569